import { io, type Socket } from "socket.io-client";

import { env } from "@/config/env";

/**
 * One socket connection, shared by every hook that needs it
 * (`useChatSocketEvents`, `useTyping`, `useSendMessage`) — none of them
 * call `io(...)` themselves. `docs/notes/sprint1.3.md`'s Socket.IO Contract
 * is what every event name/payload below matches; this module only owns
 * the connection lifecycle, not any event handling.
 *
 * Auth travels via the handshake's `auth.token`, not a header — Socket.IO's
 * initial handshake isn't a normal HTTP request `axios`'s interceptors run
 * on, so the access token has to be attached here explicitly. The server's
 * `io.use(...)` middleware (server/src/socket/index.ts) verifies it exactly
 * like `authenticate` does for REST.
 */
let socket: Socket | null = null;

export function connectSocket(token: string): Socket {
  if (socket) {
    socket.disconnect();
  }
  socket = io(env.VITE_SOCKET_URL ?? env.VITE_API_URL.replace(/\/api\/v1\/?$/, ""), {
    auth: { token },
    withCredentials: true,
  });
  return socket;
}

export function disconnectSocket(): void {
  socket?.disconnect();
  socket = null;
}

export function getSocket(): Socket | null {
  return socket;
}
